import { API_URL } from "../constants.js";
import axios from 'axios';
import middleware from '../util/middleware.js';

var request = axios.create({
    baseURL: API_URL,
    headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json'
    }
})

/**
 * Clase para ver el request de Inventario
 */
export default class InventarioBarrasRequest {
    /**
     * Llamada el endpoint de django para obtener el detalle de inventario para captura
     * en la BD
     * @param: id_drive. Id del drive seleccionado
     * @return: Una lista de artículos
     */
    static ListarArticulosInventario(id_drive) {
        return middleware.hasAuth(() => request.get(`articulos_iniciacion_inventario`, {
            params: {
                sitio_id: id_drive
            }
        }))
    }

    /**
     * Llamada el endpoint de django para capturar el inventario
     * @param: data. objeto con información de los artículos 
     * @return: Mensaje de éxito o error.
     */
     static GuardarCapturaInventario(data) {
        return middleware.hasAuth(() => request.post(`barras/inventarios`, data));
    }
    
    /**
     * Llamada el endpoint de django para obtener el encabezado de inventarios
     * en la BD
     * @param: id_drive. Id del drive seleccionado
     * @return: Una lista de histórico de inventarios
     */
    static ListarHistoricoInventario(id_drive, fechas, estatus, page) {
        return middleware.hasAuth(() => request.get(`barras/inventarios`, {
            params: {
                sitio_id: id_drive?.toString(),
                fecha_inicial: fechas[0] ?? undefined,
                fecha_final: fechas[1] ?? undefined,
                estatus: estatus?.toString(),
                page: page
            }
        }))
    }
    
    /**
     * Llamada el endpoint de django para obtener el detalle de inventarios
     * en la BD
     * @param: id_drive. Id del drive seleccionado
     * @return: Una lista de histórico de inventarios
     */
    static ListarDetalleInventario(id_drive) {
        return middleware.hasAuth(() => request.get(`inventariosDetalle`, {
            params: {
                id: id_drive
            }
        }))
    }

    /**
     * Llamada el endpoint de django para obtener el detalle de inventarios
     * en la BD
     * @param: id_drive. Id del drive seleccionado
     * @return: Una lista de histórico de inventarios
     */
    static ListarDetalleInventarioList(id_drive) {
        return middleware.hasAuth(() => request.get(`inventariosListDetalle`, {
            params: {
                id: id_drive
            }
        }))
    }
        
    /**
     * Llamada el endpoint de django para editar el inventario
     * @param: data. objeto con información de los artículos 
     * @return: Mensaje de éxito o error.
     */
    static GuardarEdicionInventario(data) {
        return middleware.hasAuth(() => request.put(`inventarios/${data.id}`, data));
    }
        
    
    /**
     * Llamada el endpoint de django para obtener la iniciacion de inventarios PT para captura
     * @param: id_drive. Id del drive seleccionado
     * @return: Una lista de artículos
     */
    static ListarArticulosInventarioPT(id_drive,externo,page) {
        return middleware.hasAuth(() => request.get(`barras/iniciacionInventario`, {
            params: {
                drive_id: id_drive,
                es_externo:externo
            }
        }))
    }
    /**
     * Llamada el endpoint de django para obtener el encabezado de inventarios
     * en la BD
     * @param: id_drive. Id del drive seleccionado
     * @return: Una lista de histórico de inventarios
     */
    static ListarHistoricoInventarioPT(id_drive, fechas,es_externo, page) {
        return middleware.hasAuth(() => request.get(`inventariosPT`, {
            params: {
                sitio_id: id_drive,
                fecha_inicial: fechas[0] ?? undefined,
                fecha_final: fechas[1] ?? undefined,
                page: page,
                es_externo:es_externo
            }
        }))
    }

    /**
     * Llamada el endpoint de django para obtener el encabezado de inventarios
     * en la BD
     * @param: id_drive. Id del drive seleccionado
     * @return: Una lista de histórico de inventarios
     */
    static ListarInventarioPT(id_drive,es_externo, page) {
        return middleware.hasAuth(() => request.get(`barras/inventarioList`, {
            params: {
                sitio_id: id_drive,
                page: page,
                es_externo:es_externo
            }
        }))
    }

    
    /**
     * Llamada el endpoint de django para capturar el inventario pt
     * @param: data. objeto con información de los artículos 
     * @return: Mensaje de éxito o error.
     */
    static GuardarCapturaInventarioPT(data) {
        return middleware.hasAuth(() => request.post(`barras/inventario`, data));
    }
    
    /**
     * Llamada el endpoint de django para obtener el detalle de inventarios
     * en la BD
     * @param: id. Id del encabezado de inventario seleccionado
     * @return: Una lista de histórico de inventarios
     */
    static ListarDetalleInventarioPT(id,page) {
        return middleware.hasAuth(() => request.get(`barras/inventarioDetalle`, {
        params: {
            id: id,
            page:page
            }
        }))
    }
    
    /**
     * Llamada el endpoint de django para obtener el detalle de inventarios
     * en la BD
     * @param: id. Id del encabezado de inventario seleccionado
     * @return: Una lista de histórico de inventarios
     */
    static ListarDetalleInventarioRpt(id,page) {
        return middleware.hasAuth(() => request.get(`barras/inventarioDtlReprt`, {
        params: {
            id: id,
            page:page
            }
        }))
    }
    
    /**
     * Llamada el endpoint de django para obtener el detalle de inventarios
     * en la BD
     * @param: id. Id del encabezado de inventario seleccionado
     * @return: Una lista de histórico de inventarios
     */
    static ListarDetalleInventarioEdit(id,page) {
        return middleware.hasAuth(() => request.get(`barras/inventarioEditDetalle`, {
        params: {
            id: id,
            page:page
            }
        }))
    }

    /**
     * Llamada el endpoint de django para editar el inventario
     * @param: data. objeto con información de los artículos 
     * @return: Mensaje de éxito o error.
     */
    static GuardarEdicionInventarioPT(data) {
        return middleware.hasAuth(() => request.put(`barras/inventario`, data));
    }

    /**
     * Llamada el endpoint de django para editar el inventario
     * @param: data. objeto con información de los artículos 
     * @return: Mensaje de éxito o error.
     */
    static ProcessInventario(data) {
        return middleware.hasAuth(() => request.put(`procesarinventario`, data));
    }

    static EliminarInventario(id_drive,es_externo, id_inventario, page) {
        return middleware.hasAuth(() => request.get(`barras/eliminar`, {
            params: {
                sitio_id: id_drive,
                page: page,
                inventario_id: id_inventario,
                es_externo:es_externo
            }
        }))
    }

    static PedidoSugerido(id_drive) {
        return middleware.hasAuth(() => request.get(`barras/pedidosugerido`, {
            params: {
                sitio_id: id_drive
            }
        }))
    }

    /**
     * Llamada el endpoint de django para validar que no sobre pase la variacion cada articulo
     * @param: data. objeto con información de los artículos 
     * @return: Mensaje de éxito o error.
     */
    static ValidarVariacionInvetarioPT(data) {
        return middleware.hasAuth(() => request.post(`variacion_inventario_pt`, data));
    }
        
}